import MUISwipeableDrawer from '@mui/material/SwipeableDrawer'
import { FC } from 'react'

import { SwipeableDrawerProps } from './swipeable-drawer.types'

export const SwipeableDrawer: FC<SwipeableDrawerProps> = ({ children, ...props }) => {
  return <MUISwipeableDrawer {...props}>{children}</MUISwipeableDrawer>
}
